export function NoPingTemplateSelected(): JSX.Element {
  return (
    <div>Please select a group to ping!</div>
  )
}
